import { createFileRoute, redirect } from '@tanstack/react-router';
import { resolveAppMode } from 'utils/appMode';
import { t } from 'utils/routeTitle';

import Dashboard from 'component/view/Dashboard';

import { requireActivePlan } from './-guards';

export const Route = createFileRoute('/n/_auth/dashboard')({
  staticData: { routeTitle: t('common.dashboard') },
  beforeLoad: async ctx => {
    const { isWpSiteControl } = resolveAppMode(ctx.location.searchStr);

    // Dashboard is not available in WP Site Control mode
    if (isWpSiteControl) {
      throw redirect({
        to: '/n/not-found',
        replace: true,
      });
    }
    await requireActivePlan(ctx);
  },
  component: Dashboard,
});
